module.exports = __webpack_public_path__ + "img/congrts.e54df839.png";